import styled from 'styled-components';
import { colors, typography, spacing } from '../../../../styles/theme';

export const Container = styled.section`
  border-top: 1px solid ${colors('default.base')};
  width: 100%;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${spacing('2')} 0;
  border-bottom: 1px solid ${colors('default.base')};
`;

export const Label = styled.strong`
  font-size: ${typography('fontSize')};
  font-weight: ${typography('weights.bold')};
`;
